<template>
  <div
    :class="[bem.b('container')]"
    :style="{ height: props.vertical ? props.verticalHeight : 'auto' }"
    v-bind="containerAttrs"
  >
    <a-slider
      v-bind="componentAttrs"
      v-model:value="sliderValue"
      :class="[
        bem.b(),
        vertical ? bem.is('vertical') : bem.is('horizontal'),
        reverse ? bem.is('reverse') : '',
        bem.is(lineWeight),
      ]"
      :min="min"
      :max="max"
      :vertical="vertical"
      :reverse="reverse"
      :disabled="disabled"
      :step="step"
    >
      <template v-for="item in Object.keys($slots)" :key="item" #[item]="data">
        <slot :name="item" v-bind="data || {}"></slot>
      </template>
    </a-slider>

    <a-form-item-rest>
      <ll-input-number
        v-if="!vertical && !attrs.range && showInput && !hasMarks"
        v-model:value="sliderValue"
        :min="min"
        :max="max"
        :disabled="disabled"
        :step="step"
        :size="inputSize"
        :style="{ width: addUnit(inputWidth) }"
      />
    </a-form-item-rest>
  </div>
</template>

<script setup lang="ts">
import { addUnit, createNamespace } from '@ll-plus/utils'
import { omit } from 'lodash-es'
import { computed, useAttrs } from 'vue'
import { sliderEmits, sliderProps } from './slider'

defineOptions({ name: 'LlSlider', inheritAttrs: false })

const props = defineProps(sliderProps)
const emit = defineEmits(sliderEmits)

const bem = createNamespace('slider')
const attrs = useAttrs()

// 容器样式
const containerAttrs = computed(() => ({
  class: attrs.class as any,
  style: attrs.style as any,
}))

// 组件功能相关的属性
const componentAttrs = computed(() => omit(attrs, ['class', 'style']))

// 使用计算属性实现双向绑定
const sliderValue = computed({
  get() {
    return props.value
  },
  set(value) {
    emit('update:value', value)
    emit('change', value)
  },
})

const hasMarks = computed(() => {
  return attrs.marks && Object.keys(attrs.marks).length > 0
})
</script>
